/**
 * PERFILES PAGE - Catálogo de Perfiles de Exámenes
 * Página independiente que reutiliza el componente PerfilesCatalogo de órdenes.
 */

import { useTranslation } from "react-i18next";
import { Layers } from "lucide-react";
import { PerfilesCatalogo } from "./components/perfiles-catalogo";

export default function PerfilesPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6">
      <div className="flex items-center gap-3">
        <Layers className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
        <div>
          <h1 className="text-lg sm:text-2xl font-bold">{t("nav.perfiles")}</h1>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t("perfiles.description", "Gestiona perfiles de exámenes agrupados")}
          </p>
        </div>
      </div>
      <PerfilesCatalogo />
    </div>
  );
}
